import { __assign, __awaiter, __extends, __generator } from "tslib";
import axios from 'axios';
import { mmUid } from 'mm-ts-utils';
import { getBrowserId } from '../_shared/library/get-browser-id';
import { getClientConfig } from '../client/src/modules/_core/utils/app-storage';
var HttpClient = /** @class */ (function () {
    function HttpClient(baseUrl, withCredentials) {
        if (withCredentials === void 0) { withCredentials = false; }
        var _this = this;
        this.get = function (url, headers) {
            if (headers === void 0) { headers = {}; }
            return _this.jsonRequest('GET', url, undefined, headers);
        };
        this.post = function (url, json, headers) {
            if (headers === void 0) { headers = {}; }
            return _this.jsonRequest('POST', url, json, headers);
        };
        this.put = function (url, json, headers, meta) {
            if (headers === void 0) { headers = {}; }
            return _this.jsonRequest('PUT', url, json, headers, meta);
        };
        this.jsonRequest = function (method, url, json, headers, meta) {
            if (headers === void 0) { headers = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var options, timeout, fullUrl, response, payload;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            options = {
                                method: method,
                                withCredentials: this.withCredentials,
                                headers: __assign(__assign({ 'X-Interaction-Id': mmUid() }, headers), { 'x-browser-id': getBrowserId() }),
                            };
                            if (json !== undefined) {
                                options.data = json;
                            }
                            // Setting timeout for request, if meta.timeout is set
                            if (meta === null || meta === void 0 ? void 0 : meta.timeout) {
                                timeout = parseInt(meta.timeout, 10);
                                if (!isNaN(timeout) && timeout > 0) {
                                    options.timeout = timeout;
                                }
                            }
                            fullUrl = this.baseUrl + url;
                            console.log('Axios request timeout, url settings:', {
                                url: fullUrl,
                                optionsTimeout: options === null || options === void 0 ? void 0 : options.timeout,
                                axiosDefaultTimeout: axios.defaults.timeout,
                            });
                            return [4 /*yield*/, axios(__assign({ url: fullUrl }, options))];
                        case 1:
                            response = _a.sent();
                            payload = response.data;
                            if (response.status >= 400) {
                                throw new RequestError(fullUrl, options, response, payload);
                            }
                            return [2 /*return*/, payload];
                    }
                });
            });
        };
        var cfg = getClientConfig();
        this.baseUrl = baseUrl;
        this.withCredentials = withCredentials;
        axios.defaults.validateStatus = function () { return true; };
        axios.defaults.timeout = cfg.HTTP_TIMEOUT_IN_MILLIS || 10000;
        axios.defaults.headers = __assign(__assign({}, axios.defaults.headers), { 
            // IE11 cache is too aggressive, see https://stackoverflow.com/q/32261000/2988107
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Caching
            Pragma: 'no-cache', 'Cache-control': 'no-store, max-age=0' });
    }
    Object.defineProperty(HttpClient.prototype, "getBaseUrl", {
        get: function () {
            return this.baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    return HttpClient;
}());
export default HttpClient;
var RequestError = /** @class */ (function (_super) {
    __extends(RequestError, _super);
    function RequestError(url, request, response, payload) {
        var _this = _super.call(this, "HTTP request ".concat(request.method, " ").concat(url, " failed with ").concat(response.status)) || this;
        _this.name = 'RequestError';
        _this.response = response;
        _this.payload = payload;
        return _this;
    }
    return RequestError;
}(Error));
export { RequestError };
